import React, { useContext, useState } from "react";

import AuthContext from "../contexts/auth/Context";
import HamBurgerIcon from "./icons/HamBurgerIcon";
import CancelIcon from "./icons/CancelIcon";
import { Link } from "react-router-dom";

const Header = () => {
  const [showNav, setShowNav] = useState(false);
  const authContext = useContext(AuthContext);
  const { isLoggedIn, logoutUser } = authContext;

  const showNavHandler = () => setShowNav(true);
  const hideNavHandler = () => setShowNav(false);

  let headerBg = "bg-transparent h-16";
  if (isLoggedIn) headerBg = "bg-brand-green-gradient h-12 lg:h-16";
  return (
    <header className={`${headerBg} flex justify-between items-center px-4`}>
      <Link
        to="/"
        className={`flex h-full py-2 lg:w-3/12 ${
          isLoggedIn ? "w-9/12 justify-left" : "w-full justify-center"
        }`}
      >
        <img
          src="/Dismissed-4-Less-Logo-Black.png"
          alt="Dismissed 4 Less Logo"
          className="h-full w-auto"
        />
      </Link>
      {isLoggedIn ? (
        <button
          type="button"
          className="h-8 w-8 md:h-10 md:w-10 lg:hidden"
          onClick={showNavHandler}
        >
          <HamBurgerIcon />
        </button>
      ) : null}
      {showNav ? (
        <nav
          className="fixed inset-0 bg-brand-green-gradient z-40 lg:static lg:hidden"
          onClick={hideNavHandler}
        >
          <button
            onClick={hideNavHandler}
            type="button"
            className="absolute h-10 w-10 right-0 mt-3 mr-3 lg:hidden"
          >
            <CancelIcon />
          </button>
          <ul className="h-full py-12 px-10 flex flex-col justify-around items-center font-black text-xl tracking-widest">
            <li>
              <Link to="/profile">Profile</Link>
            </li>
            <li>
              <Link to="/dashboard">Tickets</Link>
            </li>
            <li>
              <button
                type="button"
                onClick={logoutUser}
                className="border rounded-full border-gray-800 px-4 py-2"
              >
                Logout
              </button>
            </li>
          </ul>
        </nav>
      ) : null}
      <nav className="hidden lg:block lg:w-6/12">
        {isLoggedIn ? (
          <ul className="flex justify-around items-center font-normal text-xl tracking-widest">
            <li>
              <Link to="/profile">Profile</Link>
            </li>
            <li>
              <Link to="/dashboard">Tickets</Link>
            </li>
            <li>
              <button
                type="button"
                onClick={logoutUser}
                className="border rounded-full border-gray-800 px-4 py-2"
              >
                Logout
              </button>
            </li>
          </ul>
        ) : null}
      </nav>
    </header>
  );
};

export default Header;
